// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.delete-btn, .delete-btn:hover{color:#cf0606;}
.set-space{margin-bottom:18px;}`, "",{"version":3,"sources":["webpack://./src/app/components/customer/intakes/add-intakes-data/review-gen/review-gen.component.css"],"names":[],"mappings":"AAAA,+BAA+B,aAAa,CAAC;AAC7C,WAAW,kBAAkB,CAAC","sourcesContent":[".delete-btn, .delete-btn:hover{color:#cf0606;}\n.set-space{margin-bottom:18px;}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
